<!--
    编辑器-预览页面
    作用：预览课件制作中效果，默认以最后选择课件预览，列表进入为第一个课件预览；
    实现：；
    组件：
    注释：WJ
-->
<template>
     <div
         class="container"
         :class="{'full-screen': $route.query.fullScreen}"
     >
        <top
            v-if="!$route.query.version"
            ref="top"
            :class="{hide: isProd && this.isPractice}"
            :isMenu="false"
            :isRemark="true"
            :lesson.sync="lessonInfo"
            :isEdit="false"
            @onRemark="onRemark"
        />
        <div class="content preview">
            <!--<p v-if="isEdit" class="btn-back" @click.stop="back">-->
                <!--返回-->
            <!--</p>-->
<!--            <menus-->
<!--                ref="menus"-->
<!--                :menusData.sync="menusData"-->
<!--                :mouseEnterItem.sync="newMouseEnterItem"-->
<!--                :isOptType.sync="isOptType"-->
<!--                :isOptToBlock.sync="isOptToBlock"-->
<!--                :optToBlockItem.sync="optToBlockItem"-->
<!--                :isRemark="true"-->
<!--                @onRemark="onRemark"-->
<!--            />-->

            <div v-if="!$store.state.menusData" class="loading-go show" >
                <div class="bg-box">
                    <div class="bg">
                        <span class="lujing"></span>
                        <span class="word">LOADING</span>
                    </div>
                    <p class="title">编辑器加载中，请耐心等待哦～</p>
                </div>
            </div>
            <contents
                v-if="
                    $store.state.menusData &&
                    $store.state.menusData.blocksForm &&
                    $store.state.menusData.blocksForm.length>0 &&
                    isShow
                "
                :showType.sync="showType"
                :isPractice="isPractice"
                :isPreview="true" />
        </div>
         <Remark
            :visible.sync="isVisible"
            :data.sync="remarkData"
         />
    </div>
</template>

<script>
    import common from '../../../common'
    import top from '../top'
    // import menus from '../menus'
    import contents from '../contents'
    import Remark from '../menus/components/remark'
    import {getMessage} from "../../../../utils/messageEvent";
    // import * as MenusApi from '../../api/menusApi'
    import * as resultServer from '../../../../api/result'
    import * as commonServer from '../../../../api/common'
    import * as GlobalServer from '../../../../api/global'
    import * as LoginServer from '../../../../api/login'
    import Config from '../../../../config/app'
    import {authCookie} from "../../../../utils/enums";

    export default {
        name: "preview",
        mixins: [common],
        components: {
            top,
            // menus,
            contents,
            Remark
        },
        watch: {
            menusData: {
                handler(vl){
                    this.$store.state.menusData = vl
                },
                deep: true,
                immediate: true
            },
            '$store.state.curClassType': {
                handler(){
                    this.isShow = false
                    setTimeout(()=>{
                        this.isShow = true
                        // window.location.reload()
                    },0)
                },
                deep: true,
                immediate: false
            }
        },
        computed: {
            isProd(){
                return Config.domain === 'yunkedun.com'
            },
            // 判断是否是游戏练习
            isPractice(){
                return `${this.$route.query.is_practice}` === 'true'
            },
            // 是否编辑，如果是编辑则有返回键
            isEdit(){
                let state = false
                if((this.$route.query.isEdit && this.$store.state.permissions['class_mamage_edit']) ||
                    (this.$route.query.isEdit && this.$store.getters.isPlat) ||
                    this.$route.query.backType === 'template'){
                    state = true
                }
                return state
            },
            getResourceDetail () {
                return `${this.$route.query.is_shop}` === 'true'? 'getResourceShopDetail': 'getResourceDetail'
            }
        },
        async created() {
            const openUrl = window.location.href
            if(openUrl.indexOf('ai3.0_token')>-1){
            const aiToken = openUrl.split('&ai3.0_token=')[1]
            this.$cookie.set(authCookie.token, aiToken)
            this.$cookie.set(authCookie.client_id, 15)
            }
            if (this.$cookie.get(authCookie.token) && !this.$store.state.token){
                this.$store.state.token = this.$cookie.get(authCookie.token)
            }
            this.$store.state.saving = false
            this.$store.state.initial = true
            const self = this
            this.init()

            // 监听cocos侧发过来的通知
            this.messageEvent()

            // 设置初始化配置
            if(this.$route.query && Object.keys(this.$route.query).length>0) {
                this.$store.dispatch('setInitConfig', {
                    school_id: this.$store.state.initConfig.school_id || this.$route.query.school_id,
                    ...this.$route.query
                })
            }
            setTimeout(()=>{
                self.isShow = true
                // window.location.reload()
            },0)

            // 获取权限

            // 设置权限
            if (Object.keys(this.$store.state.permissions).length === 0) {
                let data2 = null
                let data = null
                const newObj = {}
                if(`${this.$route.query.school_id}` === '-1' || `${this.$store.state.initConfig.school_id}` === '-1'){
                    data2 = await LoginServer.getUserInfo()
                    data2.admin_permissions.forEach(v => {
                        newObj[v] = true
                    })
                }else if(`${this.$route.query.school_id}` === '0' || `${this.$store.state.initConfig.school_id}` === '0'){
                    data2 = await GlobalServer.getPermissionsByUser()
                    data = data2.platform.role_permission.code_personal
                }else {
                    let http = 'https'
                    if (Config.isDev) {
                        http = 'http'
                    }
                    data2 = await GlobalServer.getSchool()
                    this.$store.state.school = data2.school

                    const domain = this.$store.getters.getShoolConfig.domain
                    if (domain && domain.length>3) {
                        // this.$store.dispatch('initPermissions')
                        console.log('domain==>3', domain)
                        data = await GlobalServer.getPermissions({
                            url: http + '://' + domain + '/api/user'
                        })
                        data = data.school_role_permission_ids
                    }
                }
                data && data.route_names.map(v => {
                    if ((`${v}`.indexOf('management_courseware') > -1) && v.slice(22)) {
                        newObj[v.slice(22)] = true
                    }
                })
                this.$store.state.permissions = newObj
            }
        },
        // mounted(){
        //
        // },
        data(){
            return {
                isShow: false,
                isVisible: false, // 是否弹出备注
                showType: false, // 右边类型是否展开

                // 课程信息
                lessonInfo: {
                    type: 'online',
                    name: '',
                    title: '',
                    cover: ''
                },

                // 右击操作按钮
                optItem: null, // 操作右击的数据
                newMouseEnterItem: null, // 鼠标移到的数据元素
                optIsShow: false,
                optData: [{key: 'delete',value: '删除'}, {key: 'move',value: '移动'}, {key: 'copy',value: '复制'}],
                x: 0,
                y: 0,

                // 复制或移动
                isOptType: '', // 操作类型
                isOptToBlock: false,
                optToBlockItem: null,

                // 字体编辑位置
                isOperationFont: true,
                newLeft: 500,
                newTop: 300,

                // 菜单数据
                menusData: null,

                // 备注详情
                remarkData: [
                    // {
                    //     name: '板块1页面1',
                    //     content: `<p style="text-align: center">备注</p>`
                    // }
                ],
                cocosConfigAll: null,
                cocos_style: null // 练习场景选中样式
            }
        },
        methods: {
            getStatus(item){
                let state = false
                if (['game', 'tools'].includes(item.type)) {
                    const type = this.$store.state.curClassType
                    try {
                        switch (type) {
                            case 'online':
                                state = !item.config.is_online
                                if(`${item.config.is_online}` === `undefined`) state = false
                                break
                            case 'offline':
                                state = !item.config.is_offline
                                if(`${item.config.is_offline}` === `undefined`) state = false
                                break
                            case 'double_teacher':
                                state = !item.config.is_double_teacher
                                if(`${item.config.is_double_teacher}` === `undefined`) state = false
                                break
                        }

                    } catch (e) {
                        console.log('getStatus==>', e)
                    }
                }
                return state
            },
            // 返回
            back () {
                // 如果存在返回事件名，则优先执行
                if(this.$route.query.backType){
                    let obj = {
                        ...this.$route.query
                    }
                    this.$RouteUtil.template(obj)
                    return false
                }
                this.$refs.top && this.$refs.top.back()
            },
            // 整理成cocos配置
            getCocosConfig (data) {
                let newConfig = []
                try {
                    newConfig = data.blocksForm.map(v=>{
                        let lesson = []
                        // 判断菜单项是否有效
                        if(v.children && v.children.length>0) {
                            v.children.map(q => {
                                q.disabled = this.getStatus(q)
                            })
                            lesson = v.children
                            // lesson = lesson.filter(v=>!v.disabled)
                        }
                        let obj = {
                            scene: v.name,
                            lesson
                        }
                        if(v.leaf && v.leaf.length>0){
                            obj.leaf = this.getNewLeaf({data:v.leaf})
                        }
                        return obj
                    })

                    // 将newConfig 转成 [{scene:xx, lesson: [], leaf: [{scene:xx, lesson: [], leaf: []}]}]
                    newConfig = this.loopFormat({data: newConfig})
                }catch (e) {
                    console.log('获取失败cocos所有配置==>', e)
                }
                return newConfig
            },
            getNewLeaf({data}){
                console.log('data==>', data, typeof data, Array.isArray(data), data.map)
                data.map(v=>{
                    let lesson = []
                    // 判断菜单项是否有效
                    if(v.children && v.children.length>0) {
                        v.children.map(q => {
                            if(typeof q === 'object') q.disabled = this.getStatus(q)
                        })
                        lesson = v.children
                        lesson = lesson.filter(v=>!v.disabled)
                    }
                    v.lesson = lesson
                    v.scene = v.name
                    if(v.leaf && v.leaf.length>0){
                        v.leaf = this.getNewLeaf({data:v.leaf})
                    }
                })
                return data
            },
            // 将newConfig 转成 [{scene:xx, lesson: [], leaf: [{scene:xx, lesson: [], leaf: []}]}]
            loopFormat({data}){
                let obj = {}
                return data.map(v => {
                    obj = {
                        scene: v.scene,
                        lesson: v.lesson
                    }
                    if (v.leaf && v.leaf.length > 0) {
                        obj.leaf = this.getNewChilrens({data:v.leaf})
                    }
                    return obj
                })
            },
            getNewChilrens ({data}) {
                let obj = {}
                return data.map(v => {
                    obj = {
                        scene: v.scene,
                        lesson: v.lesson
                    }
                    if (v.leaf && v.leaf.length > 0) {
                        obj.leaf = this.getNewChilrens({data:v.leaf})
                    }
                    return obj
                })
            },
            // 监听cocos侧发过来的通知
            messageEvent(){
                getMessage(this.eventsList)
            },
            eventsList(e){
                // console.log('源头==>', e)
                let divs = document.querySelectorAll('.iframe-cocos')
                console.log('iframe==>', divs)
                let type = ''
                let {data} = e

                // 模拟向cocos侧发出通知
                if(data.type && data.type.substr(0,5)==='cocos'){
                    console.log('向cocos侧发出：'+data.type+'消息==>', e)
                }

                // cocos侧向web发出通知
                if(data.type && data.type.substr(0,3)==='web'){
                    console.log('向web侧发出2：'+data.type+'消息==>', e)
                    type = data.type.substr(3)
                    switch (type) {
                        case 'getExerciseInfo':
                            this.webGetCourseRoomInfo(data)
                            break
                        case 'GetConfig':
                            this.webGetConfig(data)
                            break;
                        case 'loadCompletedH5':
                        case 'loadCompleted':
                            this.webloadCompletedH5()
                            break;
                        default:
                    }
                }
            },
            webGetConfig(data){
                let value = null
                if(this.isPractice){
                    value = {cocos_remote: this.$cocosUtils.cocosConfig({data: this.menusData}),cocos_style: this.cocos_style,name: this.lessonInfo.name}
                    this.$toCocosMessage({...data, type: 'GetConfig', value})
                    return false
                }
                value = this.getCocosConfig(this.menusData)
                console.warn('向cocos通知3==>', JSON.stringify({...data, type: 'GetConfig', value}))
                this.$toCocosMessage({...data, type: 'GetConfig', value})
            },
            webGetCourseRoomInfo(data){
                const value = {
                    id: this.$route.query.practice_id,
                    token: this.$cookie.get(authCookie.token),
                    clientId: this.$cookie.get(authCookie.client_id)
                }
                if(this.$route.query.version) {
                    value.version = this.$route.query.version
                }
                this.$toCocosMessage({...data, type: 'getExerciseInfo', value})
            },
            webloadCompletedH5 (){
                let fn = setTimeout( ()=> {
                    this.$store.state.initial = false
                    clearTimeout(fn)
                }, 800)
            },
            onRemark(item, index){
                console.log(item, index)
                if(!item){
                    // 列出当前列表的所有备注
                    let data = this.$utils.curSelectedNode({})
                    this.remarkData = data.children.map((v,i)=>{
                        return {
                            name: `${data.name}-${i+1}`,
                            content: v.remark?decodeURI(v.remark):'无'
                        }
                    })
                }else {
                    this.remarkData = [
                        {
                            name: '',
                            content: decodeURI(item.remark)
                        }
                    ]
                }
                this.isVisible = true
            },
            handleClose() {
                this.dialogVisible = false
                this.$emit('close')
            },
            async init(){
                let res = null
                const config_type = 'web_edit'
                // 如果是游戏练习, 则获取游戏练习数据
                if(!this.$route.query.version && this.$route.query.practice_id){
                    res = await commonServer.default.queryExerciseGameDetail({
                        id: this.$route.query.practice_id,
                        clientsId: this.$route.query.school_id
                    })
                    this.lessonInfo.name = res.data.name
                    this.menusData = this.$utils.jsonStr2Json(res.data.attributes.h5_remote)
                    this.cocos_style =  this.$utils.jsonStr2Json(res.data.attributes.cocos_style)
                    return false
                }
                // 如果是模版，则取模版数据
                if (`${this.$route.query.is_template}` === 'true') {
                    res = await commonServer.default[this.getResourceDetail]({
                        id: this.$route.query.id,
                        clientsId: this.$route.query.school_id
                    })
                    this.menusData = res.data.attributes.h5_remote
                    this.lessonInfo = {
                        name: res.data.name,
                        title: res.data.title,
                        type: res.data.type,
                        cover: res.data.cover
                    }
                    return false
                }
                let params = {
                    id: this.$route.query.id,
                    clientsId: this.$route.query.school_id,
                    config_type
                }
                // 如果是录制记录版本 拿录制记录id换详情
                if(this.$route.query.version){

                    const version = this.$route.query.version
                    if(this.isPractice){
                        // 课后练习版本配置
                        res = await commonServer.default.queryExerciseGameVersion({
                            practiceId: this.$route.query.practice_id,
                            version
                        })
                    } else {
                        // 课件版本配置
                        params.id = version
                        params.resultId = this.$route.query.id
                        res = await resultServer.getResultRecordDetail(params)
                    }
                    // 练习版本预览
                    if(res?.data?.cocos_style)this.cocos_style =  this.$utils.jsonStr2Json(res.data.cocos_style)
                } else {
                    res = await resultServer.getResultDetail(params)
                    // if(res?.data?.attr_last?.h5_remote)res.data.attr_last.h5_remote = await resultServer.getUrlData({url: res.data.attr_last.h5_remote})
                }
                this.menusData = res.data.h5_remote || res.data.attr_last.h5_remote
                if(typeof this.menusData === 'string'){
                    this.menusData = JSON.parse(this.menusData)
                }


                this.lessonInfo = {
                    name: res.data.name,
                    title: res.data.title,
                    type: res.data.type,
                    cover: res.data.cover
                }
            },
            remarck(data){
                console.log('备注==>', data)
            }
        }
    }
</script>
<style>
    .preview .content-box{
        height: calc(100vh - 166px);
        top: 0px;
        margin: 0px 148px;
        margin-top: 56px;
    }
</style>
<style lang="scss" scoped>
.container.full-screen{
    position: absolute;
    width: 100%;
}
.container.full-screen /deep/ .container-top{
    display: none;
}
.container.full-screen .content-box{
    margin: 0px;
    margin-top: 0px;
    width: 100vw !important;
    height: 100vh !important;
}
.container.full-screen .content-box /deep/ .cocos_web{
    width: 100% !important;
    height: 100% !important;
}
.container.full-screen .btn-back{
    display: none;
}
.container{
    min-width: initial !important;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-width: 1000px;

    .hide{
        display: none;
    }

    .preview {
        //background: url("../../../../assets/images/resource/material/shuiyin.png") repeat;
        position: relative;

        .loading-go{
            background-color: white;
            position: absolute;
            left: 0px;
            top: 0px;
            /*top: 55px;*/
            width: 100%;
            height: 100%;
            /*height: calc(100% - 55px);*/
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10001;
            opacity: 0;
            z-index: -100;
            transition: all .2s linear;

            &.show{
                opacity: 1;
                z-index: 10001;
            }

            .bg-box{
                display: flex;
                flex-direction: column;
                align-items: center;

                .bg{
                    width: 116px;
                    height: 116px;
                    background-color: white;
                    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.15);
                    border-radius: 50%;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    position: relative;

                    .lujing{
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        width: 100%;
                        height: 100%;
                        background: url("../../../../assets/images/resource/material/lujing.png") no-repeat;
                        transition: all .2s linear;
                        animation: loop  2s infinite;;
                    }

                    @keyframes loop {
                        0% {
                            transform: rotateZ(0deg);
                        }
                        100% {
                            transform: rotateZ(360deg);
                        }
                    }

                    .word {
                        font-size:16px;
                        font-weight:600;
                        color:#FF7838;
                        line-height:30px;
                    }
                }
                .title{
                    font-size:18px;
                    font-weight:400;
                    color:rgba(144,147,153,1);
                    line-height:25px;
                    margin-top: 24px;
                }
            }
        }

        .btn-back {
            width: 58px;
            height: 30px;
            line-height: 30px;
            background: -webkit-gradient(linear, left top, left bottom, from(#ffbc28), to(#e7622e));
            background: linear-gradient(180deg, #ffbc28 0%, #e7622e 100%);
            box-shadow: 0px 4px 6px 0px rgba(134, 75, 0, 0.02), 0px 2px 9px 0px rgba(255, 182, 25, 0.54);
            border-radius: 20px;
            text-align: center;
            font-size: 12px;
            font-weight: 500;
            color: white;
            cursor: pointer;
            position: relative;
            left: 128px;
            top: 56px;
            letter-spacing: 2px;
            flex-shrink: 0;

            &:active {
                opacity: .8;
            }
        }
    }

    .content{
        display: flex;
        height: calc(100vh - 60px);
        flex-direction: row;
        justify-content: space-between;
    }
}
</style>
